import { defineMessages } from 'react-intl';

export default defineMessages({
    infoFromReportsAdjustedPremium: {
        id: 'ml.quoteandbind.pa.adjustments.Information from reports adjusted premium',
        defaultMessage: 'Information you entered or we received from consumer reports may have adjusted your premium'
    },
    receivedAdditionalInfoAdjustedPremium: {
        id: 'ml.quoteandbind.pa.adjustments.Received additional information adjusted premium',
        defaultMessage: 'We have received additional information which may have adjusted your premium'
    },
    premiumChangedDueToInfoReceived: {
        id: 'ml.quoteandbind.pa.adjustments.Premium changed due to information received',
        defaultMessage: 'Your premium has been changed due to information received'
    },
    autoInsurance: {
        id: 'ml.quoteandbind.pa.adjustments.Auto Insurance',
        defaultMessage: 'AUTO INSURANCE'
    },
    umbrellaInsurance: {
        id: 'ml.quoteandbind.pa.adjustments.Umbrella Insurance',
        defaultMessage: 'UMBRELLA INSURANCE'
    },
    month: {
        id: 'ml.quoteandbind.pa.adjustments.Month',
        defaultMessage: '/month'
    },
    year: {
        id: 'ml.quoteandbind.pa.adjustments.Year',
        defaultMessage: '/year'
    },
    sixMonths: {
        id: 'ml.quoteandbind.pa.adjustments.SixMonths',
        defaultMessage: '/6 months'
    },
    previousCost: {
        id: 'ml.quoteandbind.pa.adjustments.Previous Cost',
        defaultMessage: 'Previous Cost:'
    },
    reviewYourCoverages: {
        id: 'ml.quoteandbind.pa.adjustments.Review your coverages',
        defaultMessage: 'Review your coverages'
    },
    or: {
        id: 'ml.quoteandbind.pa.adjustments.OR',
        defaultMessage: 'OR'
    },
    reviewPaymentDetails: {
        id: 'ml.quoteandbind.pa.adjustments.We\'ll review your payment details next',
        defaultMessage: 'We\'ll review your {paymentDetails} next!'
    },
    paymentDetails: {
        id: 'ml.quoteandbind.pa.adjustments.payment details',
        defaultMessage: 'payment details'
    },
    violationDetails: {
        id: 'ml.quoteandbind.pa.adjustments.Violation Details',
        defaultMessage: '{person}: {date} {description}'
    },
    orderMVRforHIDriver: {
        id: 'ml.quoteandbind.pa.adjustments.Hawaii MVRs return in approximately 2-3 days. When MVR is returned, you will be able to continue to the next screen.',
        defaultMessage: 'Hawaii MVRs return in approximately 2-3 days. When MVR is returned, you will be able to continue to the next screen.'     
    }
});
